import React from 'react';

import { Grid, GridItem } from '@chakra-ui/react';

import { Host, IHostProps } from './host';

import styles from './host-list.module.scss';

export interface IHostListProps {
  hosts: IHostProps['host'][];
}

export const HostList: React.FC<React.PropsWithChildren<IHostListProps>> = ({
  hosts,
}) => {
  return (
    <Grid templateColumns="repeat(24, 1fr)" gap={4}>
      {hosts.map((host) => (
        <GridItem
          key={host.id}
          colSpan={{ base: 24, sm: 12 }}
          className={styles.hostWrapper}
        >
          <Host host={host} className={styles.host} />
        </GridItem>
      ))}
    </Grid>
  );
};
